export default __webpack_public_path__ + "static/media/dak-bg-smile-photo.7f5c8f1f.webp";